






















import { defineComponent, ref, watch } from "@vue/composition-api";

import Tooltip from "@/components/Tooltip.vue";
import { CodeMatchItem } from "@/tools/msa/models/item";

interface Props {
  item: CodeMatchItem;
  map: Map<string, CodeMatchItem[]>;
}

export default defineComponent<Props>({
  name: "RepetitionsTooltip",
  components: {
    Tooltip
  },
  props: {
    item: { type: Object, required: true },
    map: { type: Map, required: true }
  },
  setup(props: Props) {
    const classes = ref<string[]>([]);

    const length = ref<number>(0);

    watch(
      [() => props.item, () => props.map],
      () => {
        classes.value = [
          props.map.get(props.item.match.coding.code)!.length > 0 &&
          props.map.get(props.item.match.coding.code)![0] !== props.item
            ? "badge-info"
            : "badge-primary"
        ];

        length.value = (
          props.map.get(props.item.match.coding.code) || []
        ).length;
      },
      { immediate: true }
    );

    return { classes, length };
  }
});
